export class Funcao {
  constructor({
    id = null,
    nome = null,
    tipo = null,
    descricao = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.tipo = tipo;
    this.descricao = descricao;
  }
  static Build() {
    return new Funcao({
      id: null,
      nome: null,
      tipo: null,
      descricao: null,
    });
  }
  format() {
    return {
      id: this.id,
      nome: this.nome,
      tipo: this.tipo?.id,
      descricao: this.descricao,
    };
  }
}
